import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PublicFooter from '../public/PublicFooter';
import { UserContext } from '../../context/UserContext';
import { routes } from '../../config/utility';

const DEFAULT_SECTIONS = [
    { id: 'how-it-works', label: 'How It Works' },
    { id: 'key-features', label: 'Features' },
    { id: 'benefits-by-user-type', label: 'Benefits' },
    { id: 'explore-banner', label: 'Explore' },
    { id: 'organizer-cta', label: 'For Organizers' },
    { id: 'faq', label: 'FAQ' }
];

const PublicLayout = ({ children, sections = [], showSupportCTA = true }) => {
    const { user } = useContext(UserContext);
    const location = useLocation();

    const handleLogoClick = (e) => {
        // If we're on the home page, do smooth scroll to top
        if (location.pathname === routes.home) {
            e.preventDefault();
            const element = document.getElementById('top');
            if (element) {
                const headerOffset = 80; // Height of sticky header
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
        // Otherwise, let the Link component handle navigation to home
    };

    const handleSmoothScroll = (e, sectionId) => {
        e.preventDefault();
        const element = document.getElementById(sectionId);
        if (element) {
            const headerOffset = 80; // Height of sticky header
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        } else if (sectionId) {
            const targetUrl = `${window.location.origin}/#${sectionId}`;
            window.location.href = targetUrl;
        }
    };

    return (
        <div className="min-h-screen flex flex-col bg-bodyMain">
            {/* Public Header */}
            <header className="w-full sticky top-0 bg-white/80 backdrop-blur-lg border-b border-white/40 z-20">
                <div className="w-full px-4 sm:px-6 py-3 flex items-center justify-between">
                    {/* Brand */}
                    <div className="flex items-center gap-3">
                        <Link to={routes.home} onClick={handleLogoClick}>
                            <img src="/assets/FULLLOGO.svg" alt="Popout" className="h-8 w-auto cursor-pointer" />
                        </Link>
                    </div>

                    {/* Nav - desktop */}
                    <nav className="hidden md:flex items-center gap-6 text-sm text-dark/90">
                        {(sections.length > 0 ? sections : DEFAULT_SECTIONS).map((section) => (
                            <a
                                key={section.id}
                                href={`#${section.id}`}
                                onClick={(e) => handleSmoothScroll(e, section.id)}
                                className="hover:text-primary transition-colors font-medium"
                            >
                                {section.label}
                            </a>
                        ))}
                    </nav>

                    {/* Actions */}
                    <div className="flex items-center gap-2">
                        {user && user.isAuthenticated ? (
                            <a href="/dashboard" className="px-4 py-2 text-sm rounded-full bg-[#8B5CF6] text-white hover:opacity-90 transition">Dashboard</a>
                        ) : (
                            <>
                                <a href="/auth/login" className="hidden sm:inline-block px-3 py-2 text-sm rounded-full text-primary hover:bg-primary/10 transition">Sign in</a>
                                <a href="/auth/registration" className="px-4 py-2 text-sm rounded-full bg-[#8B5CF6] text-white hover:opacity-90 transition">Get Started Today</a>
                            </>
                        )}
                    </div>
                </div>
            </header>

            {/* Main */}
            <main className="flex-1" id="top">
                {children}
            </main>

            {/* Public Footer Component */}
            <PublicFooter showSupportCTA={showSupportCTA} />
        </div>
    );
};

export default PublicLayout;